import {
  InvoiceLineSummary,
  OrderLine,
  POLineData,
} from '@zonofi/zono-money-store';
import { parseInventoryStock } from './parse-inventory-stock';

function extractStock(data: POLineData): number | undefined {
  const product = (data as POLineData & { product?: Record<string, unknown> })
    ?.product;
  return (
    parseInventoryStock((data as POLineData & { stock?: unknown })?.stock) ??
    parseInventoryStock(product?.stock)
  );
}

export function mapPOLineDataToPOLine(data: POLineData): OrderLine {
  const stock = extractStock(data);
  return {
    poFileLineId: data.id,
    status: data.status,
    createdAt: new Date().toISOString(),
    sequence: data.sequence,
    uploadedProductName: data.uploadedProductName ?? '',
    // distributorProductName: data.distributorProductName ?? '',
    uploadedQty: data.uploadedQty ?? 0,
    minOrderQty: data.MOQ,
    // refOrderNumberL: data.refOrderNumber,
    orderId: data.orderId ?? 0,
    productVariantId: data.productVariantId ?? 0,
    unitPrice: String(data.unitPrice),
    unitPriceWithTax: String(data.linePriceWithTax),
    discountedUnitPrice: String(data.discountedUnitPrice),
    discountedUnitPriceWithTax: String(data.discountedLinePriceWithTax),
    proratedUnitPrice: String(data.unitPrice),
    proratedUnitPriceWithTax: String(data.proratedLinePriceWithTax),
    linePrice: String(data.linePrice),
    listPrice: String(data.listPrice),
    linePriceWithTax: String(data.linePriceWithTax),
    discountedLinePrice: String(data.discountedLinePrice),
    discountedLinePriceWithTax: String(data.discountedLinePriceWithTax),
    lineTax: String(data.linePriceWithTax - data.linePrice),
    // cfaId: data.CFAId,
    // cfa: data.CFA,
    divisionId: data.divisionId,
    divisionName: data.divisionName ?? '',
    headDivisionId: data.headDivisionId ?? '',
    // headDivisionName: data.headDivisionName ?? '',
    proratedLinePrice: String(data.proratedLinePrice),
    proratedLinePriceWithTax: String(data.proratedLinePriceWithTax),
    proratedLineTax: String(
      data.proratedLinePriceWithTax - data.proratedLinePrice
    ),
    id: data.orderLineId ?? 0,
    productVariant: {
      id: Number(data?.productVariantId ?? 0),
      productVariantId: Number(data?.productVariantId ?? 0),
      sku: String(data.product?.sku),
      MOQ: data.product?.MOQ ?? 1,
      packSize: data.product?.packSize ?? 1,
      assetUrl: '',
      translations: [
        { name: data.product?.name || data.product?.description || '' },
      ],
      additionalUOM: data.product?.additionalUOM,
      baseUOM: data.product?.baseUOM,
      facetValues: [],
      pricingStrategy: data.product?.pricingStrategy,
    },
    packSize: data.product?.packSize ?? 0,
    unitPriceWithTaxChangeSinceAdded: 0,
    totalLi: data.linePriceWithTax,
    discounts: [],
    taxLines: [],
    promotionIds: data.promotionId ? [data.promotionId] : [],
    promotionNames: data.promotionName ? [data.promotionName] : [],
    adjustedPrice: String(data.discountedLinePriceWithTax),
    invoiceLineSummary: {} as InvoiceLineSummary,
    lineDiscount: data.lineDiscount,
    poFileId: data.poFileId,
    // errorMessage: data.errorMessage ?? '',
    ...(stock !== undefined && { stock }),
    ...(data.quantity !== undefined && { quantity: data.quantity }),
    ...(data.quantity !== undefined && { newQnty: data.quantity }),
    ...(data.unitPrice !== undefined && { newPrice: data.unitPrice }),
  };
}
